const gender = {
  male: 'Lelaki',
  female: 'Perempuan',
  other: 'Other',
  wontSpecify: "Won't Specify",
};

export default gender;
